import { request } from "../../../services/api"
import type { BaseApiResponse, BasePagination } from "../../../types/api.ts"
import type { MilestoneDependency } from "../types/project-milestone-dependency.types.ts"

const BASE_URL = `/project-management/milestone-dependencies`

const PATHS = {
  getMilestoneDependencies: `${BASE_URL}/`,
  createMilestoneDependency: `${BASE_URL}/`,
  patchMilestoneDependency: (id: string) => `${BASE_URL}/${id}/`,
  deleteMilestoneDependency: (id: string) => `${BASE_URL}/${id}/`
}

export interface MilestoneDependencyWriteData {
  source_milestone: string
  target_milestone: string
  type: number
  lag_days: number
}

// Always scoped to one project — the backend returns an empty list rather
// than the full cross-tenant table when neither filter is given.
// The scheduling engine drops any edge whose source it cannot see, so a
// partial page of dependencies does not degrade gracefully — it silently
// computes a wrong schedule. Ask for the whole set in one request.
const DEPENDENCY_PAGE_SIZE = 500

export const getMilestoneDependencies = async (projectId: string) => {
  return request.api.get<
    BasePagination<MilestoneDependency>,
    BaseApiResponse<unknown>
  >(PATHS.getMilestoneDependencies, {
    project: projectId,
    page_size: DEPENDENCY_PAGE_SIZE
  })
}

export const createMilestoneDependency = async (
  data: MilestoneDependencyWriteData
) => {
  return request.api.post<
    BaseApiResponse<MilestoneDependency>,
    BaseApiResponse<unknown>
  >(PATHS.createMilestoneDependency, data)
}

export const patchMilestoneDependency = async (
  id: string,
  data: Partial<MilestoneDependencyWriteData>
) => {
  return request.api.patch<
    BaseApiResponse<MilestoneDependency>,
    BaseApiResponse<unknown>
  >(PATHS.patchMilestoneDependency(id), data)
}

export const deleteMilestoneDependency = async (id: string) => {
  return request.api.delete<BaseApiResponse<unknown>, BaseApiResponse<unknown>>(
    PATHS.deleteMilestoneDependency(id)
  )
}
